import React from "react";
import {observer} from "mobx-react";
import {useRequiredLayers} from "../../../../utils/context";
import {CartCheckoutStore, CartCheckoutStoreContext} from "../cart.checkout.store";
import {CartCheckoutController, CartCheckoutControllerContext} from "../cart.checkout.controller";
import {useTranslation} from "react-i18next";
import {Button, Modal, Row, Typography} from "antd";

export const CartCheckoutCancelOrderModal: React.FC = observer(() => {
    const {store, controller} = useRequiredLayers<CartCheckoutStore, CartCheckoutController>(CartCheckoutStoreContext, CartCheckoutControllerContext);
    const {t} = useTranslation("translation", {useSuspense: false});

    return (
        <Modal
            centered
            maskClosable={false}
            visible={store.cancelOrderModalShown}
            title={t("ORDERS.CANCEL.TITLE")}
            onCancel={controller.closeCancelOrderModal}
            footer={
                <Row justify="end">
                    <Button type="primary" onClick={controller.moveOrderToCart}>
                        {t("ORDERS.CANCEL.MOVE_TO_CART")}
                    </Button>
                    <Button danger type="primary" onClick={controller.cancelOrder}>
                        {t("ORDERS.CANCEL.TITLE")}
                    </Button>
                </Row>
            }
        >
            <Typography.Paragraph>
                {t("ORDERS.CANCEL.TEXT")}
            </Typography.Paragraph>
        </Modal>
    )
})